<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ isEdit ? 'Edit Group' : 'Add Group' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="group.name"
                  label="Group Name"
                  :rules="nameRules"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="group.description"
                  label="Description"
                  :rules="descriptionRules"
                  outlined
                  dense
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">
          Cancel
        </v-btn>
        <v-btn 
          color="primary" 
          text 
          @click="save" 
          :disabled="!valid"
          :loading="loading"
        >
          {{ isEdit ? 'Update' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { log, warn, error } from '@/utils/debugLogger';

export default {
  name: 'AddEditGroup',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editGroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      group: {
        name: '',
        description: '',
      },
      nameRules: [
        (v) => !!v || 'Group name is required',
        (v) => (v && v.length <= 100) || 'Group name must be less than 100 characters',
      ],
      descriptionRules: [
        (v) => !v || v.length <= 500 || 'Description must be less than 500 characters',
      ],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isEdit() {
      return this.editGroup && this.editGroup.id;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.resetForm();
        if (this.isEdit) {
          this.group = { ...this.editGroup };
        }
      }
    },
  },
  methods: {
    ...mapActions('GROUPS', ['CREATE', 'UPDATE']),
    
    resetForm() {
      this.group = {
        name: '',
        description: '',
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.valid = false;
    },
    
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      
      this.loading = true;
      try {
        if (this.isEdit) {
          await this.UPDATE(this.group);
        } else {
          await this.CREATE(this.group);
        }
        this.close();
        this.$emit('saved');
      } catch (error) {
        error('Error saving group:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
